import { CategoryGuids } from '../../core/constants'
import { type Transaction, TransactionType } from '../../core'

// Returns true if the transaction is not income
export const expenseFilter = (t: Transaction) =>
  t.top_level_category_guid !== CategoryGuids.INCOME && t.transaction_type === TransactionType.DEBIT

// Returns true if the transaction is an expense and it matches the search string
export const expenseFilterSearch = (t: Transaction, searchValue: string) => {
  if (expenseFilter(t)) {
    return (
      t.payee?.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.description.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.feed_description.toLowerCase().includes(searchValue.toLowerCase())
    )
  }
  return false
}

// Returns true if the transaction is income
export const incomeFilter = (t: Transaction) =>
  t.top_level_category_guid === CategoryGuids.INCOME ||
  (t.top_level_category_guid === CategoryGuids.TRANSFER &&
    t.transaction_type === TransactionType.CREDIT)

// Returns true if the transaction is income and it matches the search string
export const incomeFilterSearch = (t: Transaction, searchValue: string) => {
  if (incomeFilter(t)) {
    return (
      t.payee?.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.description?.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.feed_description?.toLowerCase().includes(searchValue.toLowerCase())
    )
  }
  return false
}
